{
    "AuthoriseButton_Title": "Autoriseer",
    "PreAuthoriseButton_Title": "Pre-autoriseer",
    "Authentication_PreAuthorisation_Successful": "Vooraf goedgekeurde",
    "Authentication_Successful": "Toestemming verleend",
    "Authentication_Failed": "Het autorisatieproces is mislukt.",
    "Authentication_Authenticated": "Deze telefonieserver is al geautoriseerd.",
    "Authentication_Status_Title": "Auth-status",
    "Authentication_Status_Warning": "Er is een waarschuwing voor deze autorisatie, je kunt proberen opnieuw te autoriseren om dit op te lossen.",
    "Authentication_Status_Warning_Range_30100_30199": "Autorisatie Succesvol, maar er is een probleem ontdekt in de communicatie met MS Teams. Neem contact op met de klantenservice van Akixi.",
    "Authentication_Status_Warning_Range_30200_30299": "Autorisatie Succesvol, maar er is een probleem gedetecteerd bij het synchroniseren met MS Teams. Neem contact op met de klantenservice van Akixi.",
    "NAME": "OAuthButton"
}